


























import Vue from 'vue';

export default Vue.extend({
  name: 'TogglePublisherAdvertiser',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    value() {
      this.toggle = this.value;
    },
  },
  methods: {
    input() {
      this.$emit('input', !this.toggle);
    },
  },
  data() {
    return {
      toggle: this.value,
    };
  },
});
